import React from "react";

export const SendOutDetailContext = React.createContext(null);

export const useSendOutDetailContext = () => {
    const context = React.useContext(SendOutDetailContext);

    if (!context) throw new Error("SendOut Detail Context not provided!");

    return context;
};
